import React from "react";
import { Button } from "@chakra-ui/react";

const SearchBar = () => {
  return <div>SearchBar</div>;
};

export default SearchBar;
